import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-row" }, [
    _vm.showCheckbox
      ? _c(
          "div",
          { staticClass: "checkbox-container" },
          [
            _c(VCheckbox, {
              staticClass: "rtls-checkbox",
              attrs: {
                indeterminate: _vm.indeterminate && !_vm.allSelectedInHierarchy,
              },
              model: {
                value: _vm.model,
                callback: function ($$v) {
                  _vm.model = $$v
                },
                expression: "model",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isPromotion
      ? _c("div", {
          staticClass: "promotion-rag-colour__colour",
          class: _vm.colorClass,
        })
      : _vm._e(),
    _vm._v(" "),
    !_vm.isPromotion
      ? _c("div", { staticClass: "promotion-name" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("toSentenceCase")(_vm.params.data.description)) +
              "\n    "
          ),
        ])
      : _c("div", { staticClass: "promotion-name" }, [
          _vm.showIcon
            ? _c(
                "span",
                [_c("icon", { attrs: { "icon-name": _vm.iconName } })],
                1
              )
            : _c("span", { staticClass: "icon-placeholder" }),
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("toSentenceCase")(_vm.params.data.description)) +
              "\n    "
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }